// HARGA-KHUSUS (owner 2026-10-11/12): pure helpers (no "@/" imports) so Jest can test them.
// The server decides and enforces everything; these only build the request and show hints.

export const ALASAN_MIN = 10;

// lowest unit price the front desk may charge: Member, else the lowest filled price (Reseller, Enduser)
export function batasBawah(b) {
  if (!b) return null;
  if ((b.harga_member || 0) > 0) return b.harga_member;
  const lain = [b.harga_reseller || 0, b.harga_enduser || 0].filter((v) => v > 0);
  return lain.length ? Math.min(...lain) : null;
}

export function alasanKurang(teks) {
  return (teks || "").trim().length < ALASAN_MIN;
}

const angka = (v) => (v === "" || v == null ? null : parseInt(v, 10));

// request fields of one line: special price (only when switched on) + discount reason
export function fieldHargaKhusus(l, discKey = "disc", alasanDiscKey = "disc_alasan") {
  const out = {};
  const hk = l.hk_on ? angka(l.harga_khusus) : null;
  if (hk != null && !Number.isNaN(hk)) {
    out.harga_khusus = hk;
    out.harga_khusus_alasan = (l.harga_khusus_alasan || "").trim() || null;
  }
  if ((parseInt(l[discKey], 10) || 0) > 0) out[alasanDiscKey] = (l[alasanDiscKey] || "").trim() || null;
  return out;
}

// form state of a stored line/variasi (revision): switch the special price on when it was used
export function stateHargaKhusus(src = {}, alasanDiscKey = "disc_alasan") {
  return {
    hk_on: src.harga_khusus != null,
    harga_khusus: src.harga_khusus ?? "",
    harga_khusus_alasan: src.harga_khusus_alasan || "",
    [alasanDiscKey]: src[alasanDiscKey] || "",
  };
}
